import axios from "axios"

export async function getTableauToken(): Promise<string> {
  return (await axios.get(`/api/snc/tableau/token`)).data
} 